import React from "react";

import EasyTrans from "../bundel/EasyTrans";
import { FormBlock } from "../ui";

function Row({ label, children }) {
  const empty =
    children === undefined ||
    children === null ||
    children === "" ||
    (Array.isArray(children) && children.length === 0);
  return (
    <div className="py-3 sm:grid sm:grid-cols-3 sm:gap-4">
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="mt-1 break-words text-sm text-gray-900 sm:col-span-2 sm:mt-0">
        {empty ? "—" : children}
      </dd>
    </div>
  );
}

const STORAGE_LABELS = {
  FAIRREGISTER_FILE_SYSTEM: "fairregister file system",
  IPFS: "IPFS",
  OWN_STORAGE: "Own storage",
};

/**
 * Read-only summary of everything entered in the wizard, shown on the final
 * step so the user can review before registering.
 */
function WorkReview({
  filename,
  type,
  title,
  description,
  licence,
  visibility,
  storageOptions = [],
  contributors = [],
  language,
  creationDate,
  identifier,
  tags = [],
}) {
  const author = contributors[0];
  return (
    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 sm:my-6 lg:my-10">
      <FormBlock
        title={<EasyTrans>RegisterWork.RegisterCheck.Title</EasyTrans>}
      >
        <div>
          <dl className="divide-y divide-gray-100">
            <Row label="File">{filename}</Row>
            <Row label="Type">{type}</Row>
            <Row label="Title">{title}</Row>
            <Row label="Description">{description}</Row>
            <Row label="License">{licence}</Row>
            <Row label="Visibility">{visibility ? "Public" : "Private"}</Row>
            <Row label="Storage">
              {storageOptions.map((s) => STORAGE_LABELS[s] || s).join(", ")}
            </Row>
            <Row label="Author">
              {author
                ? `${author.firstName || ""} ${author.lastName || ""}`.trim() ||
                  author.email
                : null}
            </Row>
            <Row label="Language">{language}</Row>
            <Row label="Creation date">{creationDate}</Row>
            <Row label="Identifier">{identifier}</Row>
            <Row label="Tags">
              {tags.length > 0
                ? tags.map((t) => t.value || t).filter(Boolean).join(", ")
                : null}
            </Row>
          </dl>
        </div>
      </FormBlock>
    </div>
  );
}

export default WorkReview;
